import type { ReactNode } from "react";
import { RightPanelGradientBackground } from "./RightPanelGradientBackground";
import { WhiteBorderWrapper } from "./WhiteBorderWrapper";

interface RightPanelProps {
  children: ReactNode;
  fullWidthChild?: boolean;
}

export const RightPanel = ({
  children,
  fullWidthChild = false,
}: RightPanelProps) => (
  <WhiteBorderWrapper>
    <RightPanelGradientBackground>
      <div
        className={fullWidthChild ? "w-full" : "w-full lg:max-w-md xl:max-w-lg"}
      >
        {children}
      </div>
    </RightPanelGradientBackground>
  </WhiteBorderWrapper>
);
